import React from 'react';
import PropTypes from 'prop-types';
import {hashHistory} from 'react-router'
import {connect} from 'react-redux';

class Index extends React.Component {
  componentWillMount() {
    const system = this.props.currentSystem
    const defaultUrl = `/${system.ID}/presentation`
    hashHistory.push(defaultUrl)
  }
  render() {
    return null
  }
}

Index.propTypes = {
  dispatch: PropTypes.func,
  currentUser: PropTypes.object,
  currentSystem: PropTypes.object
}

const mapStateToProps = function(state) {
  return {currentUser: state.user.currentUser, currentSystem: state.system.currentSystem}
}

export default connect(mapStateToProps)(Index);



// WEBPACK FOOTER //
// ./src/pages/Index.js